enum CacheKeysEnum {
	NewReviewCopies = 'newReviewCopies',
	NewReviewCopyConvoStatuses = 'newReviewCopyConvoStatuses',
	WebReaderDrcProducts = 'webReaderDrcProducts',
	SkusAvailableInWebReader = 'skusAvailableInWebReader',
}

export default CacheKeysEnum;
